<template>
    <form @submit.prevent="onSubmit()" class="form-trash">
        <div :class="`row form-content ${classPaddingParentBanner} ${classPaddingParentTop} px0`">
            <div class="col-sm-12">
                <h3 class="text-black1 medium font-weight-bold mb-20 title__normal font-16 text-center">
                    <i class="fas fa-map-pin mr-3 text-success"></i>お客様の住所をお教えください。
                </h3>
                <span class="text-red text-center font-w-600 d-block pb-30px">※現在回収エリアは、さいたま市・草加市・越谷市のみです</span>
                <!-- banner -->
                <div :class="`${classFormGroupBanner}` ">
                    <div class="form-group row">
                        <label for="example-text-input" class="col-lg-2 col-3 col-form-label text-gray label-tab-top">
                            郵便番号
                            <span class="text-danger">*</span>
                        </label>
                        <div class="col-md-9 col-lg-5" style="flex: 1">
                            <input class="form-control rounded-0 mb-2" name="zipCode" type="number" value="" placeholder="3310058"
                                v-model="zipCode" @input="onChange($event)">
                            <p class="text-left mb-0">
                                <span v-if="!$v.zipCode.required && $v.zipCode.$dirty"
                                    class="help-block error-help-block d-block">郵便番号は、必ず指定してください。
                                </span>
                                <span v-if="!$v.zipCode.zipCodeValidator && $v.zipCode.$dirty"
                                    class="help-block error-help-block d-block">郵便番号には、有効な正規表現を指定してください。
                                </span>
                                <span v-if="error" class="help-block error-help-block d-block">{{ error }}</span>
                            </p>
                        </div>
                        <div class="col-12 offset-md-3 offset-lg-0 col-md-9 col-lg-5 btn-zip-sm-top">
                            <button type="button" class="btn btn-secondary rounded-0 btnZipCode w-100"
                                @click="findByZipCode()">郵便番号から自動入力</button>
                        </div>
                    </div>
                    <div class="form-group row">
                        <label for="example-text-input" class="col-lg-2 col-3 col-form-label text-gray label-tab-top">
                            区・町名
                            <span class="text-danger">*</span>
                        </label>
                        <div class="col-md-9 col-lg-5" style="flex: 1">
                            <input placeholder="さいたま市西区飯田" type="text" class="form-control rounded-0" name="address" v-model="address"
                                @input="onChange($event)">
                            <p class="text-left mb-0">
                                <span v-if="!$v.address.required && $v.address.$dirty" class="help-block error-help-block">区・町名は、必ず指定してください。
                                </span>
                            </p>
                        </div>
                    </div>
                </div>
                <!-- top -->
                <div :class="`${classFormGroupTop}`">
                    <div class="form-group row">
                        <label for="example-text-input" class="col-lg-2 col-2 col-form-label text-gray label-tab-top">
                            郵便番号
                            <span class="text-danger">*</span>
                        </label>
                        <div class="col-md-10 col-lg-5" style="flex: 1">
                            <input class="form-control rounded-0 mb-2" name="zipCode" type="number" value=""
                                placeholder="3310058" v-model="zipCode" @input="onChange($event)">
                            <p class="text-left mb-0">
                                <span v-if="!$v.zipCode.required && $v.zipCode.$dirty" class="help-block error-help-block d-block">郵便番号は、必ず指定してください。
                                </span>
                                <span v-if="!$v.zipCode.zipCodeValidator && $v.zipCode.$dirty"
                                    class="help-block error-help-block d-block">郵便番号には、有効な正規表現を指定してください。
                                </span>
                                <span v-if="error" class="help-block error-help-block d-block">{{ error }}</span>
                            </p>
                        </div>
                        <div class="col-12 offset-md-2 offset-lg-0 col-md-10 col-lg-5 btn-zip-sm-top">
                            <button type="button" class="btn btn-secondary rounded-0 btnZipCode w-100" @click="findByZipCode()">郵便番号から自動入力</button>
                        </div>
                    </div>
                    <div class="form-group row">
                        <label for="example-text-input" class="col-lg-2 col-2 col-form-label text-gray label-tab-top">
                            区・町名
                            <span class="text-danger">*</span>
                        </label>
                        <div class="col-md-10 col-lg-5" style="flex: 1">
                            <input placeholder="さいたま市西区飯田" type="text" class="form-control rounded-0" name="address" v-model="address"
                                @input="onChange($event)">
                            <p class="text-left mb-0">
                                <span v-if="!$v.address.required && $v.address.$dirty" class="help-block error-help-block">区・町名は、必ず指定してください。
                                </span>
                            </p>
                        </div>
                    </div>
                </div>
                <div :class="`below-adv-btn text-center ${classMarginButton}`">
                    <button type="submit" class="btn bg-orange btn-info btn-submit">無料お見積もりをする</button>
                </div>
            </div>
        </div>
    </form>
</template>

<script>
    import { required, helpers } from 'vuelidate/lib/validators';
    const zipCodeValidator = helpers.regex('zipCodeRegex', /^[0-9][0-9][0-9][0-9][0-9][0-9][0-9]$/);

    export default {
        name: 'ZipCode',
        props: {
            animation: {
                default: ''
            },
            formValue: {
                zipCode: '',
                address: ''
            },
            headerClass: {
                default: ''
            },
            classPaddingParentBanner: {
                default: ''
            },
            classPaddingParentTop: {
                default: ''
            },
            classFormGroupBanner: {
                default: ''
            },
            classFormGroupTop: {
                default: ''
            },
            classMarginButton: {
                default: ''
            },
        },
        data() {
            return {
                zipCode: this.formValue.zipCode,
                address: this.formValue.address,
                error: '',
            }
        },
        validations: {
            zipCode: {
                required,
                zipCodeValidator
            },
            address: {
                required
            }
        },
        methods: {
            onChange(e) {
                this.error = '';
                let payload = {
                    label: 'general',
                    data: {
                        ...this.formValue,
                        [e.target.name]: e.target.value
                    }
                };
                this.$emit('onChangeFormValue', payload);
            },
            async findByZipCode() {
                this.$v.zipCode.$touch();
                if (!this.$v.zipCode.$invalid) {
                    let res = await axios.get(`/api/area/zipcode/${this.zipCode}`);
                    let area = res.data;
                    if (!res.data) {
                        this.error = 'このエリアは対応されていません';
                    } else {
                        area = area.city.name + ' ' + area.address;
                        this.error = '';
                        this.formValue.address = area;
                        this.address = area;
                    }
                }
            },
            validate() {
                this.$v.$touch();
            },
            async onSubmit() {
                this.validate();
                if(!this.$v.$invalid) {
                    let res = await axios.get(`/api/area/zipcode/${this.zipCode}`);
                    if (!res.data) {
                        this.error = 'このエリアは対応されていません';
                    } else {
                        this.error = '';
                        let currentStep = 2;
                        let followStep = 0;
                        this.$emit("handleChangeStep", currentStep, followStep);
                    }
                }
            },
        },
    }
</script>